import React from 'react';
import CristalProvider from '../../../Providers/Cristal';
import { CellInfo } from 'react-table';
import { PatientItem } from '../../../../components/Tables/Patients';
import { CristalContext } from '../../../../contexts/cristal';
import { Spinner } from 'reactstrap';

const CristalScoreCell = (props: CellInfo) => {
  const { value } = props as { value: PatientItem };
  return (
    <CristalProvider patientId={value.id}>
      <CristalContext.Consumer>
        {({ loading, score }) => <div>{loading ? <Spinner /> : score}</div>}
      </CristalContext.Consumer>
    </CristalProvider>
  );
};
export default CristalScoreCell;
